import { render, staticRenderFns } from "./ActivityList.vue?vue&type=template&id=167bc111&scoped=true&lang=pug"
import script from "./ActivityList.vue?vue&type=script&lang=js"
export * from "./ActivityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167bc111",
  null
  
)

export default component.exports